$(document).ready(() => {
  $('#email-share-to').on('keyup', function() {
    let emailInput = $(this);
    let emailLink = $(`#${emailInput.data('id-for')}`);
    emailLink.attr(
      'href',
      `mailto:${emailInput.val()}${emailLink.data('href-chunk')}`
    );
  });

  // Smooth scrolling to email input
  $('a[href="#email-share-to"]').on('click', function(event) {
    if (this.hash !== '') {
      event.preventDefault();
      var hash = this.hash;

      $('html, body').animate(
        {
          scrollTop: $(hash).offset().top - $('.nav-top').height() - 100
        },
        800
      );
    }
  });
});
